import { SectionProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getActiveCoverLevelOption, PolicyAdjustmentResponse } from '../../../../domain'
import { usePolicy } from '../../../product/policy/PolicyProvider'
import { MonthlyPremiumSection } from './components/MonthlyPremiumSection'
import { SinglePaymentPremiumSection } from './components/SinglePaymentPremiumSection'

export interface ProrataPremiumSectionProps extends SectionProps {
  adjustment: PolicyAdjustmentResponse
}

export const ProrataPremiumSection: FunctionComponent<ProrataPremiumSectionProps> = ({
  adjustment,
  ...props
}) => {
  const { policy } = usePolicy()

  const { quote } = policy.currentPolicyVersion

  const activeCoverLevelOption = getActiveCoverLevelOption(quote)

  switch (activeCoverLevelOption?.paymentScheduleType) {
    case 'MONTHLY':
      return <MonthlyPremiumSection adjustment={adjustment} {...props} />
    case 'SINGLE_PAYMENT':
      return <SinglePaymentPremiumSection adjustment={adjustment} {...props} />
  }
}
